"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersMenu = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var i18n_1 = __importDefault(require("../i18n"));
var PagenationMenu_1 = require("./PagenationMenu");
var withState_1 = require("../hocs/withState");
exports.UsersMenu = (0, withState_1.withState)()([
    "compactView",
    "setCompactView",
    "sortPerInstance",
    "setSortPerInstance",
]).FC(function (state) { return ((0, jsx_runtime_1.jsxs)(PagenationMenu_1.PagenationMenu, __assign({}, state, { children: [state.setCompactView ? ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Menu.Item, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Checkbox, { as: "span", toggle: true, checked: state.compactView, onChange: function (_, _a) {
                    var checked = _a.checked;
                    return state.setCompactView(Boolean(checked));
                }, label: i18n_1.default.compactView }) })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})), state.byInstance && state.setSortPerInstance ? ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Menu.Item, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Checkbox, { as: "span", toggle: true, checked: state.sortPerInstance, onChange: function (_, _a) {
                    var checked = _a.checked;
                    return state.setSortPerInstance(Boolean(checked));
                }, label: i18n_1.default.sortByInstance }) })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}))] }))); });
